var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEdit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "#1B1F23",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m4.834 24.834 2.331 2.332 2.259-1.004 19.369-19.37a2.536 2.536 0 0 0-3.586-3.585L23.414 5l2.293 2.293-1.414 1.414L22 6.414 5.838 22.576zM23.793 1.793a4.536 4.536 0 1 1 6.414 6.414L10.773 27.641c-.13.13-.284.236-.452.31l-7.727 3.435a1.5 1.5 0 0 1-1.98-1.98l3.434-7.727a1.5 1.5 0 0 1 .31-.452z"
})));
export default SvgEdit;